import React from 'react';
import './Header.css';
// import CTA from './CTA';
import ME from '../../assets/fr.jpg'
import HeaderSocials from './HeaderSocials';
const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Welcome to my portfolio page</h5>
        <h1>I am  Gibsons</h1>
        <h5 className="text-light">Full-Stack Developer, Android and Web development</h5>
        {/* <CTA/> */}
        <HeaderSocials/>
        <div className="me">
          <img src={ME}alt="dP" />
        </div>

        <a href="#contact" className='scroll__down'> Scroll Down</a>
      </div>
    </header>
  )
}

export default Header
